const COLOR_PICKER_NONE_COLOR_VALUE = "__none__";

const CUSTOM_COLOR_DROPDOWN_COLOR_PALETTE = [
  "newDarkJungleGreen",
  "newDisableText",
  "newPrimaryRegular",
  "newPurpleRegular",
  "newDarkBlueGray",
  "newEnglishLavender",
  "newByzantine",
  "newShockingPinkCrayola",
  "newPinkRegular",
  "newMaximumRed",
  "newOrangeSoda",
  "newOrangeRegular",
  "newSatinSheenGold",
  "newYellowRegular",
  "newYellowGreen",
  "newGreenRegular",
  "newPersianGreen",
  "newTurquoise",
];

export {COLOR_PICKER_NONE_COLOR_VALUE, CUSTOM_COLOR_DROPDOWN_COLOR_PALETTE};
